var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-popup",class:{ 'is-active' : _vm.isActive }},[_c('div',{staticClass:"popup-content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(this.text)}})]),_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close-popup')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }